type DifferenceFromUtcMS = number;

export function getUserTimezoneOffset(): DifferenceFromUtcMS {
  return new Date().getTimezoneOffset() * 60 * 1000 * -1;
}
